import React from 'react';
import LoadingSpinner from './loadingSpinner'
import {wsTrans, doGetPostBasic} from '../utils/utils'
import {loadSitesInfo,loadZonesInfo,loadUsersInfo,sortUsersInfo,getSiteName,getZoneName} from './C18utils'
import {cl,globs,constant,getTime} from '../../components/utils/utils';

class C18GeneralInfo00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      cropInfo:"        The tomato is the edible berry of the plant Solanum lycopersicum, commonly known as a tomato plant. The species originated in western South America and Central America. The Nahuatl (the language used by the Aztecs) word tomatl gave rise to the Spanish word tomate, from which the English word tomato derived. Its domestication and use as a cultivated food may have originated with the indigenous peoples of Mexico. The Aztecs used tomatoes in their cooking at the time of the Spanish conquest of the Aztec Empire, and after the Spanish encountered the tomato for the first time after their contact with the Aztecs, they brought the plant to Europe. From there, the tomato was introduced to other parts of the European-colonized world during the 16th century.\n        Tomatoes are a significant source of umami flavor. The tomato is consumed in diverse ways, raw or cooked, in many dishes, sauces, salads, and drinks. While tomatoes are fruits — botanically classified as berries — they are commonly used as a vegetable ingredient or side dish.\n        Numerous varieties of the tomato plant are widely grown in temperate climates across the world, with greenhouses allowing for the production of tomatoes throughout all seasons of the year. Tomato plants typically grow to 1–3 meters (3–10 ft) in height. They are vines that have a weak stem that sprawls and typically needs support. Indeterminate tomato plants are perennials in their native habitat, but are cultivated as annuals. (Determinate, or bush, plants are annuals that stop growing at a certain height and produce a crop all at once.) The size of the tomato varies according to the cultivar, with a range of 1–10 cm (1⁄2–4 in) in width.",
      zoneInfo:"      The tomato is the edible berry of the plant Solanum lycopersicum, commonly known as a tomato plant. The species originated in western South America and Central America. The Nahuatl (the language used by the Aztecs) word tomatl gave rise to the Spanish word tomate, from which the English word tomato derived. Its domestication and use as a cultivated food may have originated with the indigenous peoples of Mexico.\nThe Aztecs used tomatoes in their cooking at the time of the Spanish conquest of the Aztec Empire, and after the Spanish encountered the tomato for the first time after their contact with the Aztecs, they brought the plant to Europe. From there, the tomato was introduced to other parts of the European-colonized world during the 16th century.",
      managedBy:"",
    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveGeneralInfo)
    this.props.parms.onChange({cmd:"savePage", data:{savePage:true}})
    this.loadInfo()
    this.setBreadCrumbs()
  }
  
  saveGeneralInfo=(type)=>{
    cl(type)
    let p=this.props.parms
    cl(p)
    wsTrans("usa", {cmd: "cRest", uri: "/s/generalInfo", method: "update", 
      sessionId: globs.userData.session.sessionId, body: {
        siteId:p.site,
        zoneId:p.zone,
        cropInfo:this.state.cropInfo,
        zoneInfo:this.state.zoneInfo,
        managedBy: this.state.managedBy,
//         name:siteInfo.name,
//         weatherStation:siteInfo.weatherStation,
//         siteImage:siteInfo.siteImage,
      }})
    globs.events.publish("saveOK",true)
  }
  
  loadInfo=async()=>{
    let p=this.props.parms
    await loadUsersInfo()
    sortUsersInfo()
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/generalInfo", method: "retrieve", 
      sessionId: globs.userData.session.sessionId, body: {
//         siteId:p.site,
        zoneId:p.zone
      }})
    cl(res.data)
    let gi=res.data[0]||{cropInfo:"Please enter information about the crops", zoneInfo:"Please enter information about this zone",
      managedBy:globs.usersInfo.info[0].userId}
    this.setState({loaded:true,managedBy:gi.managedBy,cropInfo:gi.cropInfo,zoneInfo:gi.zoneInfo})
    
  }
  
  componentWillUnmount=()=>{
    this.subscribe_savePageEvent.remove()
  }
  
  setBreadCrumbs=async()=>{
    await loadSitesInfo()
    await loadZonesInfo()
    if(this.props.parms){
      let siteName=getSiteName(this.props.parms.site)
      let zoneName=getZoneName(this.props.parms.zone)
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:siteName, url:`/usa/c18/sites/${this.props.parms.site}`},
              {t:zoneName, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`},
              {t:"General Info", url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}/generalInfo`},
            ]},
        },
      )
    }
  }
  
  onChange=(type,vals)=>{
    switch(type){
      case "upd":
//         cl(type, vals)
        globs.events.publish("savePageEnable",true)
        this.setState(vals)
        break
      default:
        break
    }
  }
  
  showCropInfo=()=>{
    return(
      <>
        <h2>Crop Info</h2>

        <textarea id="crop-info" 
          value={this.state.cropInfo}
          onChange={e=>this.onChange("upd",{cropInfo:e.currentTarget.value})}>
        </textarea>
        <br />

      </>
    )
    
  }
  
  showZoneInfo=()=>{
    return(
      <>
      <h2>Zone Info</h2>

      <textarea id="zone-info"
          value={this.state.zoneInfo}
          onChange={e=>this.onChange("upd",{zoneInfo:e.currentTarget.value})}>
      </textarea>
      <br />
      </>
    )
  }
  
  showUserOpts=()=>{
    return(
      globs.usersInfo.info.map((u,i)=>{
        return(
          <option key={i} value={u.userId}>{u.name}</option>
        )
      })
    )
  }
  
  showManagedBy=()=>{
    return(
      <div className="custom-select">
        <select
          value={this.state.managedBy}
          onChange={e=>this.onChange("upd",{managedBy:e.currentTarget.value})}
        >
        {this.showUserOpts()}
        </select>
        <span className="material-icons down-arrow">
          keyboard_arrow_down
        </span>
      </div>
    )
    
  }
  
  renderO(){
    return(
      <div>
      {this.showCropInfo()}
      {this.showZoneInfo()}
      {this.showManagedBy()}
      </div>
    )
  }
  
  render(){
    if(this.state.loaded){
      return(
        <div>
          <h1>{`General Info`}</h1>
          <div id="content-area">
            <section className="link4">
              <div id="general-info-page">
                {this.showCropInfo()}
                {this.showZoneInfo()}
                {this.showManagedBy()}
              </div>  
              <div className="clearfloat"></div>
            </section>
          </div>
        </div>
      )
    }else{
  return <LoadingSpinner message="loading general info..." />
    }
  }
  
}
      
export default C18GeneralInfo00;
